import {
  Medal, UsersThree, Certificate, Truck, ShieldCheck, Gauge, WhatsappLogo,
} from "@phosphor-icons/react";
import { IMG } from "@/lib/products";
import { yearsSince, openWhatsApp } from "@/lib/site";
import { useLang } from "@/lib/i18n";
import { PageHero, SectionHeading } from "@/components/PageBits";
import { Reveal, StaggerGroup, StaggerItem } from "@/components/Reveal";
import { Counter } from "@/components/Counter";

const REASON_ICONS = [Medal, UsersThree, Certificate, Truck, ShieldCheck, Gauge];
const REASON_KEYS = ["established", "customers", "iso", "panindia", "quality", "performance"];

export default function WhyRKJain() {
  const { t } = useLang();
  const years = yearsSince();

  const stats = [
    { v: years, s: "+", l: t("stats.yearsShort") },
    { v: 50000, s: "+", l: t("stats.customersShort") },
    { v: 100, s: "%", l: t("stats.supportShort") },
    { v: t("stats.isoValue"), s: "", l: t("stats.certified") },
  ];

  return (
    <div>
      <PageHero
        eyebrow={t("why.eyebrow")}
        title={t("why.pageTitle")}
        subtitle={t("why.pageSubtitle")}
        image={IMG.heroIndustrial}
      />

      <section className="container-x py-16 md:py-24" data-testid="why-page">
        <StaggerGroup className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {REASON_KEYS.map((key, i) => {
            const Icon = REASON_ICONS[i];
            return (
              <StaggerItem key={key} className="rounded-2xl border border-hairline bg-surface p-8 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-forest/20 hover:shadow-lg hover:shadow-forest/5 md:p-10">
                <span className="flex h-16 w-16 items-center justify-center rounded-xl bg-champagne text-forest">
                  <Icon size={36} weight="thin" />
                </span>
                <h3 className="mt-6 font-heading text-xl font-bold text-forest">{t(`why.items.${key}.title`)}</h3>
                <p className="mt-3 leading-relaxed text-subtle">{t(`why.items.${key}.text`)}</p>
              </StaggerItem>
            );
          })}
        </StaggerGroup>
      </section>

      <section className="bg-champagne py-16 md:py-20">
        <div className="container-x grid grid-cols-2 gap-8 md:grid-cols-4">
          {stats.map((x, i) => (
            <Reveal key={i} className="border-l-2 border-gold pl-4">
              <div className="font-heading text-3xl font-extrabold text-forest md:text-4xl">
                <Counter value={x.v} suffix={x.s} />
              </div>
              <p className="mt-2 text-sm font-medium text-subtle">{x.l}</p>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="container-x py-16 md:py-24">
        <div className="flex flex-col items-center gap-6 text-center">
          <SectionHeading eyebrow={t("why.getInTouch")} title={t("why.getInTouchTitle")} align="center" />
          <button onClick={() => openWhatsApp()} className="btn-gold" data-testid="why-enquire-button">
            <WhatsappLogo size={20} weight="fill" /> {t("common.enquireNow")}
          </button>
        </div>
      </section>
    </div>
  );
}
